import DialogPage from "../DialogPage";
import {Image, StyleSheet, TouchableOpacity, View} from "react-native";
import {useContext, useEffect} from "react";
import {OrderContext} from "../../../contexts/OrderContext";
import AppConfigContext from "../../../contexts/AppConfigContext";
import {Colors} from "../colors";
import {ColumnSpace} from "../components/_CommonComponents";
import Text from "../components/Text";
import Button from "../components/Button";
import CTCReceiptComponents from "../../../components/functional-components/CTCReceiptComponents";
import CTCReceiptScreenFunction from "../../../components/screen-functions-components/CTCReceiptScreenFunction";

export default function CTCReceipt(props: { navigation: any }) {

    const orderContext = useContext(OrderContext);
    const colors = Colors.instanceNoServerColor(useContext(AppConfigContext).theme, useContext(AppConfigContext).color);

    return <DialogPage {...props} header={"تکمیل فرآیند پرداخت"}>
        <CTCReceiptScreenFunction>

            <CTCReceiptComponents orderContext={orderContext}>
                <CreditCardView role="card-view"/>
                <ColumnSpace/>

                <Text role="price-text" style={{textAlign: "center"}} size={20}/>
                <ColumnSpace/>

                <Text role="description-text" color={colors.get("red") as string} size={12}/>
                <ColumnSpace/>

                <ReceiptImage role="receipt-pressable"/>
                <ColumnSpace/>

                <Button role="button-save" color={colors.get("green") as string}/>
                <ColumnSpace/>

                <Button role="button-cancel" style={{width: "80%", alignSelf: "center"}} color={colors.get("red") as string}/>

            </CTCReceiptComponents>
        </CTCReceiptScreenFunction>

    </DialogPage>
}

function ReceiptImage(props: any) {
    const colors = Colors.instanceNoServerColor(useContext(AppConfigContext).theme, useContext(AppConfigContext).color);
    const style = lStyle(colors);
    return <TouchableOpacity style={[style.fileSelect]}
                             onPress={props.onPress}>
        {props.receiptFile != null ?
            <Image style={style.touchableImage} source={{uri: URL.createObjectURL(props.receiptFile)}}/>
            : <></>}
        <Text>برای بارگذاری تصویر کلیک کنید</Text>
    </TouchableOpacity>;
}

function CreditCardView(props:any) {
    if(props.card == null)
        return <></>;
    const colors = Colors.instanceNoServerColor(useContext(AppConfigContext).theme, useContext(AppConfigContext).color);
    const style = lStyle(colors);
    return <View style={style.card}>
        <Text style={{alignSelf: "flex-end"}} weight={600}
              color={colors.get("highConText") as string}>{props.card.bank}</Text>
        <ColumnSpace h={18}/>
        <View style={{
            flexDirection: "row-reverse",
            justifyContent: "space-between"
        }}>
            <Text size={20} weight={600}
                  color={colors.get("primaryColor") as string}>{props.card.number.slice(0, 4)}</Text>
            <Text size={20} weight={600}
                  color={colors.get("primaryColor") as string}>{props.card.number.slice(4, 8)}</Text>
            <Text size={20} weight={600}
                  color={colors.get("primaryColor") as string}>{props.card.number.slice(8, 12)}</Text>
            <Text size={20} weight={600}
                  color={colors.get("primaryColor") as string}>{props.card.number.slice(12, 16)}</Text>
        </View>
        {/*todo*/}
        <Text style={{alignSelf: "flex-end"}} size={12}>برای کپی کلیک کنید</Text>
        <ColumnSpace/>
        <Text color={colors.get("highConText") as string} weight={600}>{props.card.name}</Text>
    </View>
}

const lStyle = (colors: Colors) => StyleSheet.create({
    card: {
        backgroundColor: colors.get("lowConBackground") as string,
        paddingHorizontal: 16,
        borderRadius: 16,
        paddingVertical: 12
    },
    fileSelect: {
        borderStyle: "dashed", borderColor: colors.get("separator") as string,
        borderWidth: 2,
        backgroundColor: colors.get("lowConBackground") as string,
        borderRadius: 8,
        paddingVertical: 18,
        justifyContent: "center", alignItems: "center"
    },
    touchableImage: {
        borderRadius: 8,
        zIndex: 2, position: "absolute", width: "100%", height: "100%"
    }
});